import type { FC } from "react";

import { StoreDetailsCard } from "@locators/components/StoreDetails/components/StoreDetailsV2/components/StoreDetailsCard";
import type { ProductAttribute } from "@locators/components/StoreLocator";

import { AdditionalProducts, BRAND_LABELS_BY_FLAVOUR, BrandGroup, FlavourTile } from "./components";

import styles from "./StoreDetailsProductsByBrand.module.scss";

type StoreDetailsProductsByBrandProps = {
  title: string;
  evoAttribute?: ProductAttribute;
  lyoAttribute?: ProductAttribute;
  isGroupedByBrand?: boolean;
  isVendingMachineTipEnabled?: boolean;
  additionalProducts?: ProductAttribute[];
  additionalProductsIconContainerClassName?: string;
  groupName: string;
};

export const StoreDetailsProductsByBrand: FC<StoreDetailsProductsByBrandProps> = ({
  title,
  evoAttribute,
  lyoAttribute,
  isGroupedByBrand = false,
  isVendingMachineTipEnabled = false,
  additionalProducts,
  additionalProductsIconContainerClassName,
  groupName,
}) => {
  const hasEvoItems = Boolean(evoAttribute?.values?.length);
  const hasLyoItems = Boolean(lyoAttribute?.values?.length);

  const renderFlatList = () => (
    <div className={styles.storeDetailsProductsCardsTiles}>
      <AdditionalProducts
        items={additionalProducts}
        iconContainerClassName={additionalProductsIconContainerClassName}
        isHelperTipEnabled={isVendingMachineTipEnabled}
        groupName={groupName}
      />
      {hasEvoItems && evoAttribute
        ? evoAttribute.values?.map((flavour) => (
            <FlavourTile key={flavour.value} flavour={flavour} attribute={evoAttribute} groupName={groupName} />
          ))
        : null}
      {hasLyoItems && lyoAttribute
        ? lyoAttribute.values?.map((flavour) => (
            <FlavourTile key={flavour.value} flavour={flavour} attribute={lyoAttribute} groupName={groupName} />
          ))
        : null}
    </div>
  );

  const renderGroupedByBrand = () => (
    <>
      {additionalProducts?.length ? (
        <div className={styles.storeDetailsProductsCardsTiles}>
          <AdditionalProducts
            items={additionalProducts}
            iconContainerClassName={additionalProductsIconContainerClassName}
            isHelperTipEnabled={isVendingMachineTipEnabled}
            groupName={groupName}
          />
        </div>
      ) : null}
      <div className={styles.storeDetailsProductsCategoriesContainer}>
        <BrandGroup brandLabel={BRAND_LABELS_BY_FLAVOUR.EVO} attribute={evoAttribute} groupName={groupName} />
        <BrandGroup brandLabel={BRAND_LABELS_BY_FLAVOUR.LYO} attribute={lyoAttribute} groupName={groupName} />
      </div>
    </>
  );

  return (
    <StoreDetailsCard title={title}>{isGroupedByBrand ? renderGroupedByBrand() : renderFlatList()}</StoreDetailsCard>
  );
};
